module.exports = __webpack_public_path__ + "static/media/TaxiDriver.e29f9d74.png";